import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigDefaultService {

    private accountTreeViewSettings: BehaviorSubject<any>;
    private mergeAccountSequenceNumber: BehaviorSubject<any>;
    constructor(
        private http: HttpClient
    ) {
        this.accountTreeViewSettings = new BehaviorSubject<any>(null);
        this.mergeAccountSequenceNumber = new BehaviorSubject<any>(null);
    }

    async getAccountTreeViewSettings(forceReload: boolean = false) {
        const accountTreeViewSettings = this.accountTreeViewSettings?.getValue();
        if (accountTreeViewSettings && !forceReload) {
            return this.accountTreeViewSettings?.getValue();
        } else {
            await this.http.get<any>(`${environment.configUrlV2}/ModuleSetting/PhoneTemplate?moduleId=2&code=accountParentChildLevelTreeView`)
                .toPromise()
                .then(res => {
                    this.accountTreeViewSettings.next(res);
                });

            return this.accountTreeViewSettings?.getValue();
        }
    }

    async getMergeAccountSequenceNumber(forceReload: boolean = false) {
        const mergeAccountSequenceNumber = this.mergeAccountSequenceNumber?.getValue();
        if (mergeAccountSequenceNumber && !forceReload) {
            return this.mergeAccountSequenceNumber?.getValue();
        } else {
            await this.http.get<any>(`${environment.configUrlV2}/ModuleSetting/PhoneTemplate?moduleId=2&code=accountColumnMerge`)
                .toPromise()
                .then(res => {
                    this.mergeAccountSequenceNumber.next(res);
                });

            return this.mergeAccountSequenceNumber?.getValue();
        }
    }
}
